import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useDB } from "../../context/DynamoDBContext";
import {
  getResellerBaseStation,
  getResellerBeacon,
} from "../../api/ResellerApi";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import EditListInput from "../Input/EditListInput";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import {
  BaseStationSchema,
  BeaconSchema,
} from "../../validations/ResellerValidations";
import { toast } from "react-toastify";
import { EditResellerStyle } from "./EditReseller.styled";
import "./modalstyles.css";
import Popup from "./Modal";
import { ModalTitle } from "../../styles/ModalStyles";

function EditReseller({ visible, setVisible, id }) {
  const { dynamoDBClient } = useDB();
  const queryClient = useQueryClient();
  const [beacons, setBeacons] = useState([]);
  const [baseStation, setBaseStation] = useState([]);
  const [enableApi, setEnableApi] = useState(false);
  const [baseStationID, setBaseStationID] = useState("");
  const [baseStationIDError, setBaseStationIDError] = useState(false);
  const [baseStationIDStatement, setBaseStationIDStatement] = useState("");
  const [beaconIDError, setBeaconIDError] = useState(false);
  const [beaconIDErrorStatement, setBeaconIDErrorStatement] = useState("");
  const [disable, setDisable] = useState(false);
  const [beaconID, setBeaconID] = useState("");
  const [fetchQuery, setFetchQuery] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState("Loading ...");
  const [loadingStatus2, setLoadingStatus2] = useState("Loading ...");
  const [check, setCheck] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [deleteItem, setDeleteItem] = useState(null);

  useEffect(() => {
    if (!visible) {
      setBeacons([]);
      setBaseStation([]);
      setBaseStationID("");
      setBaseStationIDError(false);
      setBaseStationIDStatement("");
      setBeaconIDError(false);
      setBeaconIDErrorStatement("");
      setDisable(false);
      setBeaconID("");
      setEnableApi(false);
    }

    if (visible) {
      setEnableApi(true);
    }
  }, [visible]);

  useEffect(() => {
    if (check) {
      if (baseStation.length === 0) {
        setLoadingStatus("No Data Available");
      }
    }
  }, [baseStation]);

  useEffect(() => {
    if (check) {
      if (beacons.length === 0) {
        setLoadingStatus2("No Data Available");
      }
    }
  }, [beacons]);

  const { status: baseStationStatus, data: baseStationData } = useQuery({
    queryKey: ["TotalResellerBaseStation", id],
    queryFn: () => getResellerBaseStation(dynamoDBClient, id),
    enabled: enableApi,
    onSuccess: (data = []) => {
      if (data.length === 0) {
        setLoadingStatus("No Data Available");
      }
      setBaseStation(data);
    },
  });

  const { status: beaconStatus, data: beaconData } = useQuery({
    queryKey: ["TotalResellerBeacon", id],
    queryFn: () => getResellerBeacon(dynamoDBClient, id),
    enabled: enableApi,
    onSuccess: (data = []) => {
      if (data.length === 0) {
        setLoadingStatus2("No Data Available");
      }
      setBeacons(data);
    },
  });

  const Errors = (err) => {
    err.forEach((element) => {
      switch (element.split(":")[0]) {
        case "3":
          setBaseStationIDError(true);
          setBaseStationIDStatement(element.split(":")[1]);
          break;
        case "4":
          setBaseStationIDError(true);
          setBaseStationIDStatement(element.split(":")[1]);
          break;
        case "5":
          setBaseStationIDError(true);
          setBaseStationIDStatement(element.split(":")[1]);
          break;
        case "6":
          setBeaconIDError(true);
          setBeaconIDErrorStatement(element.split(":")[1]);
          break;
        case "7":
          setBeaconIDError(true);
          setBeaconIDErrorStatement(element.split(":")[1]);
          break;
        case "8":
          setBeaconIDError(true);
          setBeaconIDErrorStatement(element.split(":")[1]);
          break;
        default:
          // setError(true)
          // setErrorText("An Error has occured")
          break;
      }
    });
  };

  const addBaseStation2 = async (gatewayID) => {
    try {
      const uniqueId = uuidv4();
      const params1 = {
        TableName: "Resellers",
        ReturnConsumedCapacity: "TOTAL",
        Item: {
          Id: uniqueId,
          ResellerID: id,
          GatewayMAC: gatewayID,
          DateCreated: `${moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSS")}`,
          BeaconMAC: "",
          DateUpdated: "",
        },
      };
      const result = await dynamoDBClient.put(params1).promise();
      toast("GatewayMAC added Sucessfully");
      setDisable(false);
      setBaseStation((prev) => [
        ...prev,
        { GatewayMAC: gatewayID, ResellerID: id, Id: uniqueId },
      ]);
      setBaseStationID("");
      setBaseStationIDError(false);
      setBaseStationIDStatement("");
      setFetchQuery(true);
    } catch (error) {
      toast.error("Unable to add GatewayMAC.", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
      throw new Error();
    }
  };
  const addBaseStation = async (id) => {
    setDisable(true);
    const formData = {
      id,
    };
    await BaseStationSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        addBaseStation2(id);
      })
      .catch((err) => {
        Errors(err.errors);
        setDisable(false);
      });
  };

  const addBeacon2 = async (beaconID) => {
    try {
      const uniqueId = uuidv4();
      const params1 = {
        TableName: "Resellers",
        ReturnConsumedCapacity: "TOTAL",
        Item: {
          Id: uniqueId,
          ResellerID: id,
          GatewayMAC: "",
          DateCreated: `${moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSS")}`,
          BeaconMAC: beaconID,
          DateUpdated: "",
        },
      };
      const result = await dynamoDBClient.put(params1).promise();
      toast("BeaconMAC added Sucessfully");
      setDisable(false);
      setBeacons((prev) => [
        ...prev,
        { BeaconMAC: beaconID, ResellerID: id, Id: uniqueId },
      ]);
      setBeaconID("");
      setBeaconIDError(false);
      setBeaconIDErrorStatement("");
      setFetchQuery(true);
    } catch (error) {
      toast.error("Unable to add GatewayMAC.", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
      throw new Error();
    }
  };
  const addBeacon = async (id) => {
    setDisable(true);
    const formData = {
      id,
    };
    await BeaconSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        addBeacon2(id);
      })
      .catch((err) => {
        Errors(err.errors);
        setDisable(false);
      });
  };

  const deleteID = async (item) => {
    try {
      const params = {
        TableName: "Resellers",
        Key: {
          Id: item.Id,
          ResellerID: item.ResellerID,
        },
      };
      const data = await dynamoDBClient.delete(params).promise();
      setCheck(true);
      const result = baseStation.filter((gt) => gt.Id !== item.Id);
      setBaseStation(result);
      const result2 = beacons.filter((gt) => gt.Id !== item.Id);
      setBeacons(result2);
      setFetchQuery(true);
      toast("Item Deleted Successfully");
    } catch (error) {
      toast("Unable to delete Item");
      throw new Error();
    }
  };

  return (
    <>
      <Popup
        title={deleteHeading}
        visible={modal1}
        setVisible={() => {
          setModal1(false);
          setDeleteItem(null);
        }}
        message={`This Action will DELETE this item. Are you sure you want to proceed?`}
        onAccept={() => {
          setModal1(false);
          deleteID(deleteItem);
        }}
      />
      <Modal show={visible} onHide={setVisible} dialogClassName="custom-modal2">
        <Modal.Header closeButton>
          <Modal.Title>
            <ModalTitle>Update Reseller</ModalTitle>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "20px 35px" }}>
          <EditResellerStyle>
            <div>
              <h4 className="modal-header2">ResellerID: {id}</h4>
              <h6 className="text-login">Base Stations</h6>
              <div className="input-div">
                <input
                  value={baseStationID}
                  onChange={(e) => {
                    const value = e.target.value;
                    setBaseStationID(value.toLocaleUpperCase());
                    setBaseStationIDError(false);
                    setBaseStationIDStatement("");
                  }}
                  disabled={disable}
                  maxLength={12}
                  placeholder="Enter Base Station ID"
                  className={
                    baseStationIDError
                      ? "form-control error-input"
                      : "form-control input-field"
                  }
                />
                <i
                  className={
                    disable
                      ? "bi bi-plus-circle add-icon disable-icon"
                      : "bi bi-plus-circle add-icon"
                  }
                  onClick={() => addBaseStation(baseStationID)}
                  aria-disabled={disable}
                  title="Add Base Station"
                />
              </div>
              {baseStationIDError && (
                <p className="text-error">{baseStationIDStatement}</p>
              )}
              {baseStationStatus === "loading" ? (
                <p className="loading-div">Loading ...</p>
              ) : (
                <EditListInput
                  ids={baseStation}
                  title={"GatewayMAC"}
                  loading={loadingStatus}
                  onDelete={(item) => {
                    setModal1(true);
                    setDeleteHeading("Delete Base Station");
                    setDeleteItem(item);
                  }}
                />
              )}
              <div className="line" />
              <h6 className="text-login">Beacons</h6>
              <div className="input-div">
                <input
                  value={beaconID}
                  onChange={(e) => {
                    const value = e.target.value;
                    setBeaconID(value.toLocaleUpperCase());
                    setBeaconIDError(false);
                    setBeaconIDErrorStatement("");
                  }}
                  disabled={disable}
                  maxLength={12}
                  placeholder="Enter Beacon ID"
                  className={
                    beaconIDError
                      ? "form-control error-input"
                      : "form-control input-field"
                  }
                />
                <i
                  className={
                    disable
                      ? "bi bi-plus-circle add-icon disable-icon"
                      : "bi bi-plus-circle add-icon"
                  }
                  onClick={() => addBeacon(beaconID)}
                  aria-disabled={disable}
                  title="Add Beacon"
                />
              </div>
              {beaconIDError && (
                <p className="text-error">{beaconIDErrorStatement}</p>
              )}

              {beaconStatus === "loading" ? (
                <p className="loading-div">Loading ...</p>
              ) : (
                <EditListInput
                  ids={beacons}
                  onDelete={(item) => {
                    setModal1(true);
                    setDeleteHeading("Delete Beacon");
                    setDeleteItem(item);
                  }}
                  title={"BeaconMAC"}
                  loading={loadingStatus2}
                />
              )}
            </div>
          </EditResellerStyle>
        </Modal.Body>

        <Modal.Footer>
          <EditResellerStyle>
            <Button
              variant="secondary"
              onClick={() => setVisible(fetchQuery)}
              style={{ backgroundColor: "red", borderColor: "red" }}
            >
              <p className="bootstrap-btn">Close</p>
            </Button>
          </EditResellerStyle>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditReseller;
